<template>
  <SoWidget
    v-if="!hasActiveDebtPaymentPlan && !isLoading"
    ref="debt-payment-plan-widget"
    title="Debt Payment Plan"
    data-testid="debt-payment-plan-widget"
  >
    <div class="mt-6">
      <SoStatus class="mr-1" :status="eligibilityStatus" />
      <SoTooltip v-if="ineligibilityReason" :text="ineligibilityReason" large>
        <SoIcon v-if="ineligibilityReason" icon="help-circle" size="small" />
      </SoTooltip>
    </div>
    <div v-if="isEligible" class="mx-2">
      <div class="d-flex justify-space-between my-5">
        <div>Debt Balance</div>
        <div class="text-red">
          {{ balanceFormatted }}
        </div>
      </div>
      <SoButton
        title="Set up Debt Payment Plan"
        icon="arrow-up-right"
        class="pb-5"
        :to="{ name: RouteNames.CustomerFinancialsSetUpPaymentPlan }"
        data-testid="set-up-payment-plan-button"
      />
    </div>
  </SoWidget>
</template>

<script lang="ts">
  import SoStatus from "@/components/SoStatus.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { formatMoney } from "@/helpers/moneyHelpers"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { Status } from "@/types/Status"
  import { RouteNames } from "@/types/router"
  import { defineComponent } from "vue"
  import SoTooltip from "@/components/SoTooltip.vue"
  import SoIcon from "@/components/SoIcon.vue"

  export default defineComponent({
    components: {
      SoWidget,
      SoButton,
      SoStatus,
      SoTooltip,
      SoIcon,
    },
    data() {
      return {
        RouteNames,
        current: useCurrentAccountStore(),
      }
    },
    computed: {
      balanceFormatted() {
        const amount = this.current.account.data?.balance
        return amount ? formatMoney({ amount, showNegativeSign: false }) : ""
      },
      eligibilityStatus() {
        return this.isEligible
          ? new Status("caution", "Available")
          : new Status("default", "Unavailable")
      },
      hasActiveDebtPaymentPlan() {
        return !!this.current.activeDebtPaymentPlan.data
      },
      isEligible() {
        return this.current.debtPaymentPlanEligibility.data.isEligible
      },
      ineligibilityReason() {
        return this.current.debtPaymentPlanEligibility.data.ineligibilityReason
      },
      isLoading() {
        return this.current.debtPaymentPlanEligibility.isFetching
      },
    },
  })
</script>
